import styled from 'styled-components';
import { InfoCircleOutlined } from '@ant-design/icons';

export const StyledResiliencyWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 500px;
  flex-direction: column;
`;

export const StyledDatePickerWrapper = styled.div`
  padding: 5px;
  padding-right: 50px;
`;

export const StyledTopPanelWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  margin-bottom: 10px;

  h4 {
    margin-bottom: 0;
    margin-left: 10px;
  }
`;

export const StyledPanel = styled.div`
  background-color: #fff;
  padding: 8px;
  height: calc(100% - 50px);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const StyledFilterPanel = styled.div`
  margin-bottom: 10px;
  border-bottom: 1px solid #e8e8e8;
`;

export const StyledTooltipIcon = styled(InfoCircleOutlined)`
  margin-left: 10px;
  cursor: pointer;
`;
